import ROLES from "../../data/Roles";
import { UserStorage } from "../tools/UserStorage";

export class GodMode {
  static get isGodMode() {
    if (typeof window !== "undefined") {
      const userRole = UserStorage.getLoggedUser()?.role;
      return userRole === ROLES.SUPPORT;
    }

    return false;
  }
}
